'use es6';

import TwoFactorAuthLevels from '../constants/TwoFactorAuthLevels';
import { createSelector } from 'reselect';
import TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import TwoFactorAuthHSAppStatuses from '../constants/TwoFactorAuthHSAppStatuses';
export const getIsInvalidTokenAlertVisible = state => state.twoFactorAuth.get('isInvalidTokenAlertVisible');
export const getIsTokenExpiredAlertVisible = state => state.twoFactorAuth.get('isTokenExpiredAlertVisible');
export const getIsGenericTwoFactorErrorAlertVisible = state => state.twoFactorAuth.get('isGenericTwoFactorErrorAlertVisible');
export const getIsInvalidCodeAlertVisible = state => state.twoFactorAuth.get('isInvalidCodeAlertVisible');
export const getIsNewCodeSentAlertVisible = state => state.twoFactorAuth.get('isNewCodeSentAlertVisible');
export const getIsSmsRateLimitAlertVisible = state => state.twoFactorAuth.get('isSmsRateLimitAlertVisible');
export const getIsUserDeactivatedAlertVisible = state => state.twoFactorAuth.get('isUserDeactivatedAlertVisible');
export const getToken = state => state.twoFactorAuth.get('token');
export const getIsVerifying = state => state.twoFactorAuth.get('isVerifying');
export const getIsRequestingCode = state => state.twoFactorAuth.get('isRequestingCode');
export const getTotp = state => state.twoFactorAuth.get('totp');
export const getEmail = state => state.twoFactorAuth.get('credentials').email;
export const getPassword = state => state.twoFactorAuth.get('credentials').password;
export const getRememberThisDevice = state => state.twoFactorAuth.get('rememberThisDevice');
export const getBackupCodesEnabled = state => state.twoFactorAuth.get('backupCodesEnabled');
export const getAppState = state => state.twoFactorAuth.get('appState');
export const getRememberLogin = state => state.twoFactorAuth.get('credentials').rememberLogin;

const getPrimary = state => state.twoFactorAuth.get('primary');

const getPrimaryMethod = state => state.twoFactorAuth.getIn(['primary', 'method']);

const getSecondary = state => state.twoFactorAuth.get('secondary');

const getSecondaryMethod = state => state.twoFactorAuth.getIn(['secondary', 'method']);

export const getTwoFactorLevel = state => state.twoFactorAuth.get('twoFactorLevel');
export const isPrimaryMethod = createSelector([getTwoFactorLevel], twoFactorLevel => {
  return twoFactorLevel === TwoFactorAuthLevels.PRIMARY;
});
export const hasSecondaryMethod = createSelector([getSecondary], secondary => secondary !== null);
export const getTwoFactorMethod = createSelector([getTwoFactorLevel, getPrimary, getSecondary], (twoFactorLevel, primary, secondary) => {
  return twoFactorLevel === TwoFactorAuthLevels.PRIMARY ? primary : secondary;
});
export const getTwoFactorMethodMethod = createSelector([getTwoFactorMethod], twoFactorMethod => twoFactorMethod.method);
export const getPhoneNumber = createSelector([getTwoFactorMethod], twoFactorMethod => twoFactorMethod && twoFactorMethod.get('obfuscatedInfo') ? twoFactorMethod.get('obfuscatedInfo') : '');
export const getAreBothGoogleAuth = createSelector([getPrimaryMethod, getSecondaryMethod], (primaryMethod, secondaryMethod) => primaryMethod === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR && secondaryMethod === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR);
export const isHubspotAuthRequestResponded = state => !!state.twoFactorAuth.get('hubspotAuthenticatorResponse');
export const isHubspotAuthenticatorErrorVisible = state => state.twoFactorAuth.get('hubspotAuthenticatorResponse') && state.twoFactorAuth.get('hubspotAuthenticatorResponse') !== TwoFactorAuthHSAppStatuses.APPROVED;
export const getIsRememberThisDeviceModalOpen = state => state.twoFactorAuth.get('isRememberThisDeviceModalOpen');
export const getIsLoginWithHSPrompt = state => state.twoFactorAuth.get('isLoginWithHSPrompt');